import {Injectable} from '@angular/core';
import {AuthService, RestClientService} from 'shared-lib';
import {map, Observable} from 'rxjs';
import {OnboardingData} from './models/onboarding-data';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {

  private userId: string | undefined;

  constructor(private restClient: RestClientService, private authService: AuthService) {
    this.authService.getCurrentUser$().subscribe(user => {
      if (user) {
        this.userId = user.id;
      }
    });
  }

  public getOnboardingData(): Observable<OnboardingData> {
    if (!this.userId) {
      throw new Error('User not logged in!');
    }

    return this.restClient.get<OnboardingData>(`/onboarding/${this.userId}/data`)
      .pipe(map(response => {
        if (response.firstVisit) {
          response.firstVisit = new Date(response.firstVisit);
        }

        return response;
      }));
  }
}
